import { useStaticQuery, graphql } from "gatsby"

const useDistributorQuery = () => {
  const { allDatoCmsDistributor } = useStaticQuery(graphql`
  query Distributors {
    allDatoCmsDistributor (
      filter: {hideForLocale: {ne: true}}
      sort: {position: DESC}
    ) {
      nodes {
        id
        originalId
        title
        address
        postcode
        state
        wholesaler
        retailer
        email
        phone
        fax
        googleMap {
          latitude
          longitude
        }
        group
      }
    }
  }
`)

  return allDatoCmsDistributor.nodes
}

export default useDistributorQuery